/**
 * 提供 request 方法短时间内相同 api 调用合并请求的能力
 * 1. 默认不开启（通过传入 hasCanSingle 参数控制）
 * 2. 通过 url 来判断是否为同一 api 请求，如需要定制判断请传入 singleFunc
 * @method single
 * @param {Function} func request 方法
 * @return {Function} 包装后的 request 方法
 */

import { isFunction } from '@/utils/verify';

const requestPromise = {};

const _getRequestKey = (options = {}) => {
  const { url = '', singleFunc } = options;
  return isFunction(singleFunc) ? singleFunc(options) : url;
};

const single = func => options => {
  const { hasCanSingle = false } = options;
 
  if (!hasCanSingle) return func(options);

  const requestKey = _getRequestKey(options);

  if (requestPromise[requestKey]) return requestPromise[requestKey];

  const promise = func(options);
  requestPromise[requestKey] = promise;

  return promise.finally(() => delete requestPromise[requestKey]);
};
 
export default single;
